export type PunchoutOrderGuideApiItem = {
  itemNumber: string;
  productName: string;
  brandName: string;
  isCompanySpecified: boolean;
  catalogName: string;
  par: number;
  uom: string;
};

export type PunchoutOrderGuideItem = {
  rowId: string;
  attributes?: string[];
  itemNum?: string;
  brand?: string;
  description?: string;
  catalog?: string;
  maxNum?: number;
  uom?: string;
};

const toGridString = (value: string | null | undefined): string => value?.trim() ?? '';

export const mapPunchoutOrderGuideItem = (
  item: PunchoutOrderGuideApiItem,
  index: number
): PunchoutOrderGuideItem => ({
  rowId: `${item.itemNumber}-${index}`,
  attributes: item.isCompanySpecified ? ['isFormulary'] : [],
  itemNum: toGridString(item.itemNumber),
  brand: toGridString(item.brandName),
  description: toGridString(item.productName),
  catalog: toGridString(item.catalogName),
  maxNum: item.par,
  uom: toGridString(item.uom),
});
